<app-navbar></app-navbar>

<div class="content-container">
    <sb-sidenav class="left-panel">
        <button class="create-request-link-btn" (click)="openRequestModal()">
            <i class="fa fa-plus icon-status" aria-hidden="true"></i>
            {{ 'Create a request link' | translate }}
        </button>

        <ul class="nav nav-pills flex-column">
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="allRequestsRouterLinkActiveOptions"
                    style="padding: 13px 10px 13px 20px !important">
                    <i class="fa fa-list icon-status icon-status_all-requests" aria-hidden="true"></i>
                    {{ 'All requests' | translate }}
                </a>
            </li>
        </ul>

        <div class="mt-3 ps-3 mb-2">
            {{ 'Request status' | translate }}
        </div>
        <ul class="nav nav-pills flex-column">
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ requestStatus: personalDataRequestStatusEnum.created }"
                    routerLinkActive="active">
                    <i class="fa fa-circle-dot icon-status icon-status_created" aria-hidden="true"></i>
                    {{ 'Created' | translate }}
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ requestStatus: personalDataRequestStatusEnum.readByUser }"
                    routerLinkActive="active">
                    <i class="fa fa-adjust icon-status icon-status_read-by-user" aria-hidden="true"></i>
                    {{ 'Read by user' | translate }}
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ requestStatus: personalDataRequestStatusEnum.requestSubmitted }"
                    routerLinkActive="active">
                    <i class="fa fa-circle icon-status icon-status_request-submited" aria-hidden="true"></i>
                    {{ 'Request submitted' | translate }}
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ requestStatus: personalDataRequestStatusEnum.archived }"
                    routerLinkActive="active">
                    <i class="fa fa-archive icon-status icon-status_archive" aria-hidden="true"></i>
                    {{ 'Archive' | translate }}
                </a>
            </li>
        </ul>

        <div class="mt-3 ps-3 mb-2">
            {{ 'Link status' | translate }}
        </div>
        <ul class="nav nav-pills flex-column">
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ isLinkExpired: false }"
                    routerLinkActive="active">
                    <i class="fa fa-link icon-status icon-status_active" aria-hidden="true"></i>
                    {{ 'Active' | translate }}
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ isLinkExpired: true }"
                    routerLinkActive="active">
                    <i class="fa fa-link icon-status icon-status_expired" aria-hidden="true"></i>
                    {{ 'Expired' | translate }}
                </a>
            </li>
        </ul>
        <div class="mt-3 ps-3 mb-2">
            {{ 'File Status' | translate }}
        </div>
        <ul class="nav nav-pills flex-column">
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ resultFileStatus: requestFileStatusEnum.available }"
                    routerLinkActive="active">
                    <i class="fa fa-file-lines icon-status icon-status_available" aria-hidden="true"></i>
                    {{ 'Available' | translate }}
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ resultFileStatus: requestFileStatusEnum.notCreated }"
                    routerLinkActive="active">
                    <i class="fa fa-file icon-status icon-status_not-created" aria-hidden="true"></i>
                    {{ 'Not created' | translate }}
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link"
                    [routerLink]="['/', communityName, portalName, 'requests']"
                    [queryParams]="{ resultFileStatus: requestFileStatusEnum.deleted }"
                    routerLinkActive="active">
                    <i class="fa fa-trash icon-status icon-status_deleted" aria-hidden="true"></i>
                    {{ 'Deleted' | translate }}
                </a>
            </li>
        </ul>
    </sb-sidenav>

    <div class="main-content" [ngClass]="{ 'ps-0': !sideNavigationService.isLeftMenuOpen }">
        <h1 class="portal-title">
            <i class="fa-solid fa-shield-halved icon-status icon-status_read-by-user icon-big" aria-hidden="true"></i>
            {{ 'Customer Data Access Requests' | translate }}
        </h1>
        <div class="requests-block">
            <div class="request-list">
                <div
                    style="height: 100%; overflow: auto"
                    infiniteScroll
                    [infiniteScrollDistance]="2"
                    [infiniteScrollDisabled]="isLoading"
                    (scrolled)="onScroll()"
                    [scrollWindow]="false">
                    <div [hidden]="requests.length || isLoading" class="alert" role="alert">
                        {{ 'No requests match these criteria' | translate }}
                    </div>
                    <div (click)="showRequestDetail()" class="list-group" style="overflow: hidden">
                        @for (request of requests; track request) {
                            <a
                                class="list-group-item list-group-item-action"
                                [routerLink]="['detail', request.id]"
                                routerLinkActive="active"
                                queryParamsHandling="preserve">
                                <div>
                                    <app-request-status-icon [status]="request.status"></app-request-status-icon>
                                    {{ ('Request' | translate) + ' #' + request.id }}
                                    <span class="right">
                                        {{ request.creationTime | date: 'dd.MM.yyyy' }}
                                    </span>
                                </div>
                                <div class="list-group-item__request-text truncate">
                                    {{ request.internalReference }}
                                </div>
                            </a>
                        }
                        @if (isLoading) {
                            <sb-loader class="mt-4"></sb-loader>
                        }
                    </div>
                </div>
            </div>

            <div class="request-details">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <div
        class="background"
        (click)="sideNavigationService.toggleSidebar()"
        [ngClass]="{ 'd-block': sideNavigationService.isLeftMenuOpen }"></div>
</div>
